/**
 * Application-wide constants. Anything that might reasonably change — timings,
 * limits, defaults — lives here rather than being hardcoded at call sites.
 */
export const APP_CONFIG = {
  /** Default options applied to every TanStack Query. */
  query: {
    staleTimeMs: 30_000,
    gcTimeMs: 5 * 60_000,
    retry: 2,
  },
  /** Orchestration canvas defaults. */
  canvas: {
    /** Snap-to-grid step in canvas units. */
    gridSize: 16,
    /** Spacing of the background dot grid (visual only). */
    dotGap: 20,
    /** Default zoom applied when fitting the view. */
    minZoom: 0.2,
    maxZoom: 2,
    /** Offset applied so dropped nodes are centered under the cursor. */
    nodeDropOffset: { x: 110, y: 40 },
  },
  /** AI streaming behaviour. */
  ai: {
    /** Abort a stream that produces no data for this long (ms). */
    idleTimeoutMs: 30_000,
    /** Inter-token delay used by the mock generator (ms). */
    mockTokenDelayMs: 24,
  },
} as const
